import React, { createContext, useContext, useEffect } from 'react';

const UTMContext = createContext();

function UTMProvider({ children }) {
  useEffect(() => {
    if (typeof window === 'undefined') { return; }

    const urlParams = new URLSearchParams(window.location.search);
    const utmData = {};
    let hasUtm = false;

    function toCamelCase(str) {
      return str.replace(/[_-](\w)/g, (_, letter) => letter.toUpperCase());
    }

    urlParams.forEach((value, key) => {
      if (key.startsWith('utm_') || key.startsWith('utm-')) {
        const camelKey = toCamelCase(key);
        utmData[camelKey] = value;
        hasUtm = true;
      } else if (key === 'attr_m') {
        utmData[key] = value;
        hasUtm = true;
      }
    });

    if (hasUtm) {
      try {
        sessionStorage.setItem('utm', JSON.stringify(utmData));
      } catch (e) {
        console.error('Failed to store UTM data:', e);
      }
    }
  }, []);

  return (
    <UTMContext.Provider value={{}}>
      {children}
    </UTMContext.Provider>
  );
}

function useUTM() {
  const context = useContext(UTMContext);
  if (context === undefined) {
    throw new Error('useUTM must be used within a UTMProvider');
  }
  return context;
}

export { UTMProvider, UTMContext, useUTM };
